import { render } from "./editPage.vue?vue&type=template&id=7b7a2900"
import script from "./editPage.vue?vue&type=script&lang=js"
export * from "./editPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__